import { SettingsInputComponentOutlined } from '@mui/icons-material'
import { checkManufacturability } from 'features/BillOfMaterials/store/asyncActions/checkManufacturability'
import { bomItemSelector } from 'features/BillOfMaterials/store/selectors/bomItemSelector'
import { projectInBuyerViewSelector } from 'features/BillOfMaterials/store/selectors/projectInBuyerViewSelector'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { useAppSelector } from 'store/configureStore'
import { BomItemMenuItem } from './BomItemMenuItem'

export const CheckManufacturabilityMenuItem = ({
  bomItemPointer,
  onClose,
}: {
  bomItemPointer: BomItemPointer
  onClose: () => void
}) => {
  const manufacturabilityCheckEnabled = useAppSelector((state) => {
    const bomItem = bomItemSelector(state, bomItemPointer)

    switch (bomItem?.type) {
      case BomItemType.partType:
        return bomItem.canCheckManufacturability
      default:
        return false
    }
  })

  const isBuyerView = useAppSelector(projectInBuyerViewSelector)

  if (isBuyerView || !manufacturabilityCheckEnabled) {
    return null
  }

  return (
    <BomItemMenuItem
      action={checkManufacturability}
      actionParams={{ bomItemId: bomItemPointer.id }}
      closeAfterFullfilled
      onClose={onClose}
      primaryTextTranslationKey="project:context-check-manufacturability"
      secondaryTextTranslationKey="project:context-check-manufacturability-desc"
      icon={<SettingsInputComponentOutlined />}
    />
  )
}
